import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 10,
    fontFamily: 'Helvetica',
    lineHeight: 1.4,
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: "space-between",
    alignItems: "flex-start"
  },
  headerRight: {
    width: "25%",
  },
  row: {
    flexDirection: 'row',
    justifyContent: "space-between",
  },
  column: {
    flex: 1,
    paddingRight: 8,
    flexDirection: 'column',
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCol: {
    flex: 1,
    paddingRight: 8,
  },
  alignText: {
    width: 33,
    textAlign: 'right',
  },
  header: {
    fontSize: 20,
    lineHeight: 1.2,
  },
  subHeader: {
    fontSize: 14,
    marginBottom: 4,
  },
  label: {
    fontWeight: 'bold',
  },
  spacer: {
    height: 14
  },
  miniSpacer: {
    height: 4
  },
  line: {
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#000000',
  },
  firstCol: {
    width: "21%",
    paddingRight: 5,
  },
  tableColW: {
    width: "13.4%",
    paddingRight: 5,
  },
  lastCol: {
    width: "12%",
    paddingRight: 5,
  },
  headerTextFirstCol: {
    fontWeight: "bold",
  },
  headerText: {
    fontWeight: "bold",
    textAlign: "right",
  },
  alignTableText: {
    textAlign: "right",
  },
  alignTableTextFirstCol: {
    textAlign: "left",
  },
});

export default styles;
